module.exports = __webpack_public_path__ + "img/robot01_finish.509251b9.png";